import jQuery from 'jquery';
import limitLines from './limitLines';

class ProductSearch {
    constructor(container) {
        this.$container = jQuery(container);
        this.progressTimer = null;
        this.increaseProgressTimer = null;
    }

    init() {
        const $that = this.$container;
        let search;
        const $formContainer = jQuery('.product-list .filter-form');

        $formContainer.on('submit', (e) => {
            e.preventDefault();
            ProductSearch.searchFilter($formContainer);
        });

        $that.on('change', (event) => {
            const parent = jQuery(event.target).closest('.filter-form__multiselect');
            const selectedCount = parent.find('input:checked').length;
            const selectedCountElement = parent.find('.filter-form__filter-count');

            $formContainer.find("input[name='page']").val('1');

            if (selectedCount > 0) {
                selectedCountElement.html(selectedCount);
                selectedCountElement.addClass('visible');
            } else {
                selectedCountElement.removeClass('visible');
            }

            clearTimeout(search);
            search = setTimeout(() => $formContainer.submit(), 2000);
        });

        const openedMultiselectClass = 'filter-form__multiselect--opened';

        $that
            .on('mousedown', '.filter-form__title', (e) => {
                e.preventDefault();
            })
            .on('click', '.filter-form__title', (e) => {
                const $currentParent = jQuery(e.currentTarget).closest('.filter-form__multiselect');
                if ($currentParent.hasClass(openedMultiselectClass)) {
                    $currentParent.removeClass(openedMultiselectClass);
                } else {
                    jQuery(`.${openedMultiselectClass}`).removeClass(openedMultiselectClass);
                    $currentParent.addClass(openedMultiselectClass);
                }
            })
            .on('focusin', '.filter-form__multiselect__container', (e) => {
                if (!jQuery(e.currentTarget).closest(`.${openedMultiselectClass}`).length) {
                    jQuery(e.currentTarget).find('.filter-form__title').trigger('click');
                }
            });

        // slide dropdown up when clicked outside
        jQuery(document).click((event) => {
            const $target = jQuery(event.target);
            if (!$target.closest(`.${openedMultiselectClass}`).length) {
                jQuery(`.${openedMultiselectClass}`).removeClass(openedMultiselectClass);
            }
        });

        window.onpopstate = () => {
            ProductSearch.updatePage($formContainer, window.location.search.substring(1));
        };

        jQuery('.product-list .pagination').on('click', 'a', (e) => {
            e.preventDefault();
            const $productList = jQuery('.product-list__list');
            ProductSearch.updatePage($formContainer, e.currentTarget.search.substring(1));
            const offset = $productList.offset().top
                - parseInt($productList.css('margin-top'), 10)
                - jQuery('.header').outerHeight(true);
            jQuery([document.documentElement, document.body]).animate({
                scrollTop: offset,
            }, 300);
        });
    }

    static updateProgress(percent, increase = false) {
        const progress = percent / 100;
        const progressSelector = '.filter-form__progress';

        jQuery(progressSelector).data('progress', progress).css('transform', `scaleX(${progress})`).css('opacity', '1');

        if (percent < 100) {
            jQuery(progressSelector).removeClass('full');
        } else {
            if (this.progressTimer) clearTimeout(this.progressTimer);
            this.progressTimer = setTimeout(
                () =>
                    jQuery(progressSelector)
                        .addClass('full')
                        .css('opacity', '0')
                        .css('transform', 'scaleX(0)'),
                1000,
            );
        }

        if (increase) {
            this.increaseProgressTimer = setTimeout(() => ProductSearch.increaseProgress(progressSelector, 0.9), 300);
        } else if (this.increaseProgressTimer) clearTimeout(this.increaseProgressTimer);
    }

    static increaseProgress(progressSelector, maxProgress) {
        const currentProgress = jQuery(progressSelector).data('progress');
        if (currentProgress < maxProgress) {
            const progress = currentProgress + 0.1;
            jQuery(progressSelector).data('progress', progress).css('transform', `scaleX(${progress})`);

            this.increaseProgressTimer = setTimeout(() => ProductSearch.increaseProgress(progressSelector, 0.9), 300);
        } else {
            clearTimeout(this.increaseProgressTimer);
        }
    }

    static updatePage(formContainer, url) {
        const page = ProductSearch.getUrlParameter('page', url) || 1;
        formContainer.find("input[name='page']").val(page);
        formContainer.submit();
    }

    static getUrlParameter(sParam, sPageURL) {
        const sURLVariables = sPageURL.split('&');
        let result = null;

        for (let i = 0; i < sURLVariables.length; i++) {
            const sParameterName = sURLVariables[i].split('=');
            if (sParameterName[0] === sParam) {
                result = sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
        return result;
    }

    static searchFilter(formContainer) {
        const formBox = formContainer;
        const data = formBox.serialize();
        const dataArray = formBox.serializeArray();
        const url = document.createElement('a');
        url.href = formBox[0].action;
        const formUrl = url.pathname;
        const fullUrl = decodeURI(`${formUrl}?${data}`);
        const requestMethod = formBox[0].method;
        const $listContainer = jQuery('.product-list__list');
        const $listNoItems = jQuery('.product-list__no-items');
        const $listError = jQuery('.product-list__error');

        function nl2br(string) {
            return string.replace(/(?:\r\n|\r|\n)/g, '<br>');
        }

        if (!window.history.state || window.history.state.page !== fullUrl) {
            window.history.pushState({ page: fullUrl }, document.title, fullUrl);
        }

        ProductSearch.updateProgress(10);

        $listContainer.addClass('loading').html('').fadeIn(0);
        for (let i = 0; i < 4; i++) {
            $listContainer.append(`
            <li data-index="${i}" class="product-list__item product-list__item--dummy">
                <div class="product-list__image"></div>
                <div class="product-list__details">
                    <div class="product-list__title"></div>
                    <div class="product-list__excerpt"></div>
                    <div class="product-list__price"></div>
                    <div class="btn--dummy"></div>
                </div>
            </li>`);
        }

        ProductSearch.updateProgress(30, true);

        jQuery.ajax({
            url: formUrl,
            type: requestMethod,
            dataType: 'json',
            accepts: {
                json: 'application/json',
            },
            data,
            success(response) {
                ProductSearch.updateProgress(90);
                try {
                    const {
                        urls,
                        max_pages: maxPages,
                        current_page_results: pageProducts,
                        current_page: currentPage,
                    } = response;
                    const productsCount = pageProducts.length;

                    if (productsCount > 0) {
                        for (let i = 0; i < 24; i++) {
                            if (i < productsCount) {
                                const product = pageProducts[i];
                                const prices = [];
                                const productImage = product.image || null;

                                // check smallest price
                                for (let id = 0; id < product.sizeVariants.length; ++id) {
                                    prices.push(product.sizeVariants[id].price);
                                }

                                const smallestPrice = Math.min(...prices) || null;

                                const content = `
                                <li data-index="${i}" class="product-list__item product-list__item--loaded">
                                    <a href="${urls[product.id]}">
                                        <div class="product-list__image">
                                            ${productImage ? `
                                                <img src="${productImage}" alt="${product.title}">
                                            ` : ''}
                                        </div>
                                    </a>
                                    <div class="product-list__details">
                                        ${product.title ? `
                                        <h3 class="product-list__title">
                                            <a href="${urls[product.id]}">${product.title}</a>
                                        </h3>
                                        ` : ''}
                                        <div class="product-list__excerpt">
                                            ${product.summary ? `
                                                <a href="${urls[product.id]}">${nl2br(product.summary)}</a>
                                            ` : ''}
                                        </div>
                                        ${smallestPrice ? `
                                        <strong class="product-list__price">
                                            <a href="${urls[product.id]}">od ${smallestPrice} zł</a>
                                        </strong>
                                        ` : ''}
                                        <a href="${urls[product.id]}" class="btn">
                                            Więcej
                                        </a>
                                    </div>
                                </li>
                                `;

                                if ($listContainer.find(`[data-index='${i}']`).length) {
                                    $listContainer
                                        .find(`[data-index='${i}']`)
                                        .replaceWith(content);
                                } else {
                                    $listContainer
                                        .append(content);
                                }
                            } else {
                                $listContainer
                                    .find(`[data-index='${i}']`)
                                    .remove();
                            }
                        }

                        $listNoItems.fadeOut();
                        $listError.fadeOut();

                        jQuery('.product-list__excerpt a').each((index, el) => {
                            limitLines(jQuery(el)[0], 3);
                        });

                        ProductSearch.renderPagination(currentPage, maxPages, formUrl, dataArray);
                    } else {
                        $listNoItems.fadeOut();
                        $listContainer.fadeOut();
                        $listNoItems.fadeIn();
                    }
                    ProductSearch.updateProgress(100);
                } catch (error) {
                    $listNoItems.fadeOut();
                    $listContainer.fadeOut();
                    $listError.fadeIn();
                    ProductSearch.updateProgress(0);
                    // console.error(error);
                }

                $listContainer.removeClass('loading');
            },
            error() {
                $listNoItems.fadeOut();
                $listContainer.fadeOut();
                $listError.fadeIn();
                ProductSearch.updateProgress(0);
            },
        });
    }

    static renderPagination(currentPage, maxPages, url, dataArray) {
        let template = '';

        if (maxPages > 1) {
            const newArray = dataArray;

            dataArray.forEach((value, index) => {
                if (value.name === 'page') {
                    newArray.splice(index);
                }
            });

            const params = jQuery.param(newArray);

            template = `
            <nav>
                ${currentPage > 1 ? `
                    <a href="${url}?${params}&page=${currentPage - 1}" rel="prev">
                        <i class="pagination-arrow-prev icon icon-arrow"></i>
                    </a>
                    ${currentPage === maxPages && maxPages > 2 ? `
                        <a href="${url}?${params}&page=${currentPage - 2}">${currentPage - 2}</a>
                    ` : ''}
                    <a href="${url}?${params}&page=${currentPage - 1}">${currentPage - 1}</a>
                ` : ''}
                <span class="current">${currentPage}</span>
                ${currentPage < maxPages ? `
                    <a href="${url}?${params}&page=${currentPage + 1}">${currentPage + 1}</a>
                    ${currentPage === 1 && maxPages > 2 ? `
                        <a href="${url}?${params}&page=${currentPage + 2}">${currentPage + 2}</a>
                    ` : ''}
                    <a href="${url}?${params}&page=${currentPage + 1}" rel="next">
                        <i class="pagination-arrow-next icon icon-arrow"></i>
                    </a>
                ` : ''}
            </nav>
            `;
        }
        jQuery('.product-list .pagination').html(template);
    }
}

export { ProductSearch };
